export interface Document {
  title: string;
  url: string;
  cover: {
    src: string;
  };
}

export interface AnnualDocuments {
  fiscalyear: string;
  documents: Document[];
}

export const documents: AnnualDocuments[] = [
  {
    fiscalyear: "2023-24",
    documents: [
      {
        title: "Annual Report",
        url: "/docs/investors/fy2324-annual-report.pdf",
        cover: { src: "/images/investors/fy2324-annual-report.png" },
      },
      {
        title: "Form MGT-7",
        url: "/docs/investors/fy2324-form-mgt-7.pdf",
        cover: { src: "/images/investors/fy2324-form-mgt-7.png" },
      },
      {
        title: "AGM Notice",
        url: "/docs/investors/fy2324-agm-notice.pdf",
        cover: { src: "/images/investors/fy2324-agm-notice.png" },
      },
    ],
  },
  {
    fiscalyear: "2022-23",
    documents: [
      {
        title: "Annual Report",
        url: "/docs/investors/fy2223-annual-report.pdf",
        cover: { src: "/images/investors/fy2223-annual-report.png" },
      },
      {
        title: "Form MGT-7",
        url: "/docs/investors/fy2223-form-mgt-7.pdf",
        cover: { src: "/images/investors/fy2223-form-mgt-7.png" },
      },
      {
        title: "AGM Notice",
        url: "/docs/investors/fy2223-agm-notice.pdf",
        cover: { src: "/images/investors/fy2223-agm-notice.png" },
      },
    ],
  },
  {
    fiscalyear: "2021-22",
    documents: [
      {
        title: "Annual Report",
        url: "/docs/investors/fy2122-annual-report.pdf",
        cover: { src: "/images/investors/fy2122-annual-report.png" },
      },
      {
        title: "Form MGT-7",
        url: "/docs/investors/fy2122-form-mgt-7.pdf",
        cover: { src: "/images/investors/fy2122-form-mgt-7.png" },
      },
      {
        title: "AGM Notice",
        url: "/docs/investors/fy2122-agm-notice.pdf",
        cover: { src: "/images/investors/fy2122-agm-notice.png" },
      },
      {
        title: "Director's Resignation Letter",
        url: "/docs/investors/fy2122-director-resignation-letter.pdf",
        cover: {
          src: "/images/investors/fy2122-director-resignation-letter.png",
        },
      },
    ],
  },
];
